import React from 'react';
import { Box, Button, Chip, Typography } from '@mui/material';

const MIME_LABELS = {
  'application/pdf': 'PDF',
  'image/jpeg': 'JPG',
  'image/png': 'PNG',
  'image/gif': 'GIF',
  'image/webp': 'WEBP',
  'image/svg+xml': 'SVG',
  'application/msword': 'DOC',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'DOCX',
  'application/vnd.ms-excel': 'XLS',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'XLSX',
  'text/csv': 'CSV',
  'video/mp4': 'MP4',
  'video/webm': 'WEBM',
  'video/ogg': 'OGG',
  'audio/mpeg': 'MP3',
  'audio/ogg': 'OGG',
  'audio/wav': 'WAV',
  'application/zip': 'ZIP',
  'application/x-zip-compressed': 'ZIP',
};

function dedupe(labels) {
  return [...new Set(labels)];
}

export default function FileUploadPreview({ field, palette }) {
  const upload = field?.upload || {};
  const allowedMimes = upload.allowedMimeTypes || [];
  const maxFiles = upload.maxFiles;

  const typeLabels = dedupe(allowedMimes.map((m) => MIME_LABELS[m] || m));

  return (
    <Box
      sx={{
        border: `1px dashed ${palette.border}`,
        borderRadius: '8px',
        p: 1,
        display: 'flex',
        flexDirection: 'column',
        gap: 0.75,
      }}
    >
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.75 }}>
        <Chip size="small" label="example-file.pdf" sx={{ fontSize: '11px' }} disabled />
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
        <Button
          variant="outlined"
          size="small"
          disabled
          sx={{ textTransform: 'none', fontSize: '12px', flexShrink: 0 }}
        >
          Upload file
        </Button>
        {(typeLabels.length > 0 || maxFiles) && (
          <Typography sx={{ fontSize: '11px', color: palette.textSecondary }}>
            {[
              typeLabels.length > 0 && typeLabels.join(', '),
              maxFiles && `max ${maxFiles} file${maxFiles > 1 ? 's' : ''}`,
            ]
              .filter(Boolean)
              .join(' · ')}
          </Typography>
        )}
      </Box>
    </Box>
  );
}
